import styles from "@styles/pages/oraculo/database-customer-table.module.scss";
import { Currency } from "@utils/Currency";
import { Numbers } from "@utils/Numbers";
import { Phone } from "@utils/Phone";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const CustomerTableItem = ({ customer, onClick }) => {
  return (
    <tr
      onClick={() => onClick && onClick(customer)}
      className={css({ customer: true, table: true })}
    >
      <td>
        <div className="d-flex align-center">
          <div className={styles.icon}>
            <i className={`fas fa-${getIcon(customer)}`} />
          </div>
          <p>{Phone.format(customer.phone)}</p>
          <span>/</span>
          <p>{customer.name || "Nome não registrado!"}</p>
        </div>
      </td>
      <td>
        <div className="d-flex">
          <div
            className={`${
              styles["progress-completeness"]
            } ${getClassCompleteness(customer)}`}
          >
            {Math.trunc(calculateCompleteness(customer))}%
          </div>
        </div>
      </td>
      <td>
        <p>{Currency.formatCurrency(+customer.total_orders || 0)}</p>
      </td>
      <td>
        <p>{Numbers.formatInt(customer.count_orders)}</p>
      </td>
    </tr>
  );
};

const getIcon = (customer) => {
  switch (customer) {
    case customer.phone: {
      return "phone";
    }
    case customer.doc: {
      return "address-card";
    }
    case customer.email: {
      return "envelope-open";
    }
    default: {
      return "phone";
    }
  }
};

const isArrayEmpty = (value) => {
  return Array.isArray(value) && value.length == 0;
};

const calculateCompleteness = (data) => {
  const values = [];
  const controllers = ["phone", "name", "email", "birthdate", "addresses"];
  controllers.map((item) => {
    if (
      data[item] !== undefined &&
      !isArrayEmpty(data[item]) &&
      data[item] !== null &&
      data[item] != "" &&
      data[item] != "0000-00-00"
    )
      values.push(data[item]);
  });

  return (values.length * 100) / 5;
};

const getClassCompleteness = (data) => {
  const value = calculateCompleteness(data);

  if (value < 30) {
    return styles.red;
  }

  if (value < 80) {
    return styles.yellow;
  }

  return styles.green;
};
